'use client';

import Image from 'next/image';
import { useState } from 'react';
import { IconLine } from '@tabler/icons-react';
import { Badge } from '../../ui/Badge';
import { Button } from '../../ui/Button';

export const SectionIntro = ({
  description,
  sectionName,
  subSections,
  questionCount,
  remainingQuestions,
  changePage,
}: {
  description: string;
  sectionName: string;
  subSections: Array<string>;
  questionCount: number;
  remainingQuestions: number;
  changePage: (page: number) => void;
}) => {
  const [loading, setLoading] = useState(false);
  return (
    <div className="flex flex-col items-start gap-2.5 p-6 relative bg-white rounded-2xl overflow-hidden border border-solid border-color-styles-gray-200">
      <div className="flex-col gap-6 flex items-start relative self-stretch w-full flex-[0_0_auto]">
        <div className="flex-col gap-6 flex items-start relative self-stretch w-full flex-[0_0_auto]">
          <div className="gap-6 flex items-start relative self-stretch w-full flex-[0_0_auto]">
            <div className="relative flex-1 mt-[-1.00px] text-2xl font-bold text-[#1d2939]">
              {sectionName}
            </div>
            <Badge
              className="badge-instance mr-3 mb-3"
              color="primary"
              icon={'false'}
              outline={false}
              size="lg"
              text={`${remainingQuestions} ${remainingQuestions == 1 ? 'Question' : 'Questions'} Remaining`}
              textClassName="design-component-instance-node"
            />
          </div>
          <div className="flex flex-wrap w-100 items-start gap-[8px_8px] relative flex-[0_0_auto]">
            {subSections.map((key: string) => {
              return (
                <Badge
                  key={key}
                  className="badge-instance mr-3 mb-3"
                  color="primary"
                  icon={'false'}
                  outline={false}
                  size="lg"
                  text={key}
                  textClassName="design-component-instance-node"
                />
              );
            })}
          </div>
          <span
            className={'text-xl font-bold'}
          >{`${questionCount} Questions`}</span>
        </div>
        <IconLine
          className="relative w-[1200px] h-px object-cover"
          style={{
            width: '100%',
            height: '1px',
            backgroundColor: '#e5e5e5',
          }}
        />
        <div className="flex-col gap-4 flex items-start relative self-stretch w-full flex-[0_0_auto]">
          <div className="relative w-[335.33px] mt-[-1.00px] text-[#1d2939] text-xl font-bold">
            Section Overview
          </div>
          <p className="relative self-stretch font-text-md-regular font-[number:var(--text-md-regular-font-weight)] text-tokens-text-secondary text-[length:var(--text-md-regular-font-size)] tracking-[var(--text-md-regular-letter-spacing)] leading-[var(--text-md-regular-line-height)] [font-style:var(--text-md-regular-font-style)]">
            {description}
          </p>
        </div>
        <div className="flex  items-center justify-center">
          <Button
            variant="primary"
            suffixIcon="/icons/arrow_right.svg"
            text="Begin"
            onClick={() => changePage(1)}
          />
        </div>
      </div>
    </div>
  );
};
